import React from 'react'

export default function certificateManagement() {
  return (
    <div>certificateManagement</div>
  )
}
